import type { PerfumeBrief } from "./api";
import styles from "./PerfumeName.module.css";

export interface PerfumeNameProps {
  perfume: PerfumeBrief | null;
  /** The source's words, shown when no perfume database found the perfume. */
  smellsLike: string;
  size?: "sm" | "md";
}

/** The perfume a formula smells like: its bottle, its name, brand and year. */
export function PerfumeName({ perfume, smellsLike, size = "md" }: PerfumeNameProps) {
  const facts = perfume ? [perfume.brand, perfume.year].filter(Boolean).join(", ") : "";
  return (
    <span className={styles.perfume} data-size={size}>
      {perfume?.image_url ? <img src={perfume.image_url} alt="" className={styles.bottle} loading="lazy" /> : null}
      <span className={styles.text}>
        <span className={styles.name}>{perfume ? perfume.name : smellsLike}</span>
        {facts ? <span className={styles.facts}>{facts}</span> : null}
      </span>
    </span>
  );
}
